import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { DataSourceStorageType } from '../pocdesigner/service';
import { ThemeService } from 'src/app/shared';


@Component({
    selector: 'dataSource',
    templateUrl: 'dataSource.component.html'
})

export class DataSourceComponent {

    // public storageOptions: string[] = [
    //     'FILE_DFS', 'FILE_S3', 'MONGO',
    //     'HIVE', 'HBASE', 'CLASSPATH', 'MYSQL',
    //     'REDIS', 'ORACLE', 'REDSHIFT'];
    public dataSourceData: any = {
        id: null, name: '', catalog: '', schema: '', dataSourceCode: '',
        username: '', newPassword: '', type: '', deleted: 0
    };
    public mainPage: boolean = true;
    public dataSourceReg: string = '';
    public lastRegex: string = '';
    public sPage: number = 0;
    public dataSourcePage: boolean = false;
    public dataSourceList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public isEdit: boolean = false;
    public noServerName: boolean = false;
    public dataEngineList: any = [];
    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public currentPage: number = 1;
    public selectedSourceId: number;
    public endingPage: number;
    public totalSource: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;
    public isConnection: boolean = false;
    public connectionLabel: string;
    public parameters: any;
    public isSSaSS = false;

    constructor(
        public dataSourceService: MDMService,
        public toastr: ToasterComponent, public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    public ngOnInit() {
        if (this.dataSourceService.isBIAdmin) {
            this.loadDataSource();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedSourceId == null) {
            this.selectedSourceId = event.target.id;
        } else {
            this.selectedSourceId = null;
        }
    }

    public closeDropDown(event){
        this.selectedSourceId = null;
    }

    // For Pagination
    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.dataSourceReg != '') {
            this.searchPDataSource();
        } else {
            this.loadDataSource();
        }
        this.setEndingPage(this.totalSource);
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    // For Pagination
    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalSource / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadDataSource();
    }

    public loadDataSource() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            this.dataSourceService.getDataByPage(BiUrls.DATASOURCE, self.pageNo,
                self.pageSize).then((res) => {
                    self.dataSourceList = [];
                    self.totalPages = 0;
                    self.totalSource = 0;
                    if (res != undefined) {
                        self.dataSourceList = res.data != undefined &&
                            res.data.pageElements != undefined ? res.data.pageElements :
                            self.toastr.showError('No results found');
                        self.totalSource = res.data != undefined &&
                            res.data.total != undefined ? res.data.total : 0;
                    }
                    self.setEndingPage(self.totalSource);
                    self.loader = false;
                    // self.loadEngine();
                    resolve('completed');
                }, (error) => {
                    console.error(error);
                });
        });
    }

    // By Lalu
    public searchPDataSource() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.mainPage = true;
            self.dataSourceList = [];
            if (self.dataSourceReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.dataSourceReg;
            self.dataSourceService.search(BiUrls.DATASOURCE, BiUrls.SEARCH_P_DATASOURCE,
                self.dataSourceReg, self.pageNo, self.pageSize).then((res) => {
                    self.loadSearchedPDataSource(res);
                    self.loader = false;
                }, (error) => {
                    console.error(error);
                });
            resolve('completed');
        });

    }

    // By Lalu
    public loadSearchedPDataSource(res) {
        let self = this;
        if (res != undefined) {
            self.dataSourceList = res.data.pageElements;
            self.totalSource = res.data.total;
        } else {
            self.totalSource = 0;
        }
        self.setEndingPage(self.totalSource);
    }

    public loadEngineByType(dataEngine) {
        return new Promise((resolve) => {
            let self = this;
            this.dataSourceService.onStartUp(BiUrls.DATAENGINE + BiUrls.GET_ENGINE_BY_TYPE + dataEngine).then((res)=>{
                res != undefined && res.data != undefined ? self.dataEngineList.push(...res.data) : null;
                resolve('completed');
            });
        });
    }

    public addNewDataSource(dsType) {
        let storageType = new DataSourceStorageType();
        this.mainPage = false;
        this.dataSourcePage = true;
        let type = storageType[dsType].engineType;
        this.dataEngineList = [];
        if(typeof type == 'string'){
            this.loadEngineByType(storageType[dsType].engineType);
        }else{
            type.forEach(t=>{
                this.loadEngineByType(t);
            });
        }
        this.parameters = storageType[dsType].customParameter ? storageType[dsType].customParameter : null;
        this.dataSourceData = {
            id: null, name: '', catalog: '', schema: '',
            username: '', newPassword: '', type: '', deleted: 0,
            connection : null,
            customParameter1 : null,
            customParameter2 : null,
            customParameter3 : null,
            customParameter4 : null,
            customParameter5 : null,
            location: null,
            storageType: dsType,
            dataEngine: null, dataEngineId: null
        };
        // storageType[dsType].type ? storageType[dsType].type :
        this.isConnection = storageType[dsType].connection != undefined ? true : false;
        this.connectionLabel = (this.isConnection && storageType[dsType].connection != '') ? 
         storageType[dsType].connection : 'Connection';
    }

    public onSave() {
        let self = this;
        let validate: any = this.validator();
        if (validate != '') {
            self.toastr.showError(validate);
        } else {
            self.saveButton = true;
            self.loader = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.dataSourceService.update(BiUrls.DATASOURCE, self.dataSourceData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                console.log('ON SAVE');
                self.dataSourceService.save(BiUrls.DATASOURCE, self.dataSourceData).then((res) => {
                    let result = res;
                    self.loadAfterSaveOrEdit(result, 'new');
                });
            }
        }
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalSource / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        let text = type == 'new' ? 'Data Source saved successfully' : 'Changes saved successfully';
        if (self.dataSourceReg != '') {
            self.searchPDataSource().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Unable to save Data Source');
                }
            });
        } else {
            self.setPageFieldsAfterLoading();
            self.loadDataSource().then((res) => {
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Unable to save Data Source');
                }
            }, (error) => {
                console.error(error);
            });
        }
        self.currentPage = self.pageNo + 1;
    }

    public setPageFieldsAfterLoading() {
        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.selectedSourceId = null;
        self.dataSourcePage = false;
        self.isEdit = false;
        self.loader = false;
    }

    public clickEdit(dataSource) {
        let self = this;
        self.loader = true;
        self.selectedSourceId = null;
        self.dataSourceService.getDataById(BiUrls.DATASOURCE, dataSource.id).then((res) => {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Data Source');
            } else {
                dataSource = res.data;
                this.isSSaSS = res.data.storageType == 'SQLSERVER' && res.data.dataEngine.type != 'PRESTO';
                self.isEdit = true;
                self.mainPage = false;
                self.dataSourcePage = true;
                self.dataSourceData = JSON.parse(JSON.stringify(dataSource));
            }
            self.setParams();
            self.loader = false;
        }, (error) => {
            console.error(error);
        });

    }

    setParams(){
        if(this.dataSourceData){
            this.parameters = [];
            this.dataEngineList = [];
            this.dataSourceData.dataEngine.type == 'SSAS' ? this.loadEngineByType('PRESTO') : null;
            this.loadEngineByType(this.dataSourceData.dataEngine.type);
            let DStype = this.dataSourceData.storageType;
            let storageType = new DataSourceStorageType();
            this.isConnection = storageType[DStype].hasOwnProperty('connection') ? true : false;
            if (storageType[DStype]) {
                this.parameters = storageType[DStype].customParameter ? storageType[DStype].customParameter : null;
                this.connectionLabel = (this.isConnection && storageType[DStype].connection != '') ? 
                storageType[DStype].connection : 'Connection';
            }
            
        }
    }

    // public onSelectStorageType(event) {
    //     let self = this;
    //     self.selectedStorageType = event.target.value;
    //
    // }

    public onBack() {
        this.mainPage = true;
        this.dataSourcePage = false;
        this.selectedSourceId = null;
        this.isEdit = false;
    }

    onTest(){
        let self = this;
        let validate: any = this.validator();
        if (validate != '') {
            self.toastr.showError(validate);
        } else {
            self.loader = true;
            self.dataSourceService.testConnection(BiUrls.ANALYTICAL_SERVICE + BiUrls.TEST_CONNECTION, self.dataSourceData).then((res) => {
                if (res.success && res.message) {
                    self.toastr.showSuccess(res.message);
                } else if (res.success) {
                    self.toastr.showSuccess('Data Source Connected successfully');
                } else if (res.success == false && res.message != undefined) {
                    self.toastr.showError(res.message);
                } else {
                    self.toastr.showError('Failed to Test Data Source Connection');
                }
                self.loader = false;
            });
        }
    }

    public delete(dataSource) {
        let self = this;
        self.loader = true;
        self.dataSourceService.delete(BiUrls.DATASOURCE, dataSource.id).then((response) => {
            if (response.error == undefined) {
                self.toastr.showSuccess(dataSource.name + ' removed successfully');
            } else {
                self.toastr.showError('Unable to remove Data Source');
            }
            self.pageNo = self.dataSourceList.length == 1 ?
                self.totalSource == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadDataSource();
        }, (error) => {
            console.error(error);
        });
    }

    public removeDataSource(dataSource) {
        let r = confirm('Are you sure you want to remove the data source '
            + dataSource.name + ' ?');
        if (r == true) {
            this.delete(dataSource);
        }
    }

    public validator() {
        if (this.dataSourceData.name == undefined || this.dataSourceData.name.trim() == '') {
            return 'Please enter the name it cannot be empty';
        }
        if (this.dataSourceData.dataEngineId == undefined ||
            this.dataSourceData.dataEngineId == null) {
            return 'Please enter the dataEngine it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.catalog == undefined || this.dataSourceData.catalog.trim() == '')) {
            return 'Please enter the catalog it cannot be empty';
        }
        if (this.dataSourceData.schema == undefined || this.dataSourceData.schema.trim() == '') {
            return 'Please enter the schema it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.location == undefined || this.dataSourceData.location.trim() == '')) {
            return 'Please enter the location it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.username == undefined ||
            this.dataSourceData.username.trim() == '')) {
            return 'Please enter the username it cannot be empty';
        }
        if (!this.isSSaSS && this.dataSourceData.id == undefined &&
            (this.dataSourceData.newPassword == undefined ||
                this.dataSourceData.newPassword.trim() == '')) {
            return 'Please enter the password it cannot be empty';
        }
        if(this.parameters && this.parameters.length != 0){
            let msg = '';
            this.parameters.forEach((param,i)=>{
                if (msg == '') {
                    let dsData = this.dataSourceData['customParameter' + (i + 1)];
                    if (dsData == undefined || dsData == null || dsData.trim() == '') {
                        msg = 'Please enter the ' + param + ' Parameter it cannot be empty';
                    } else {
                        msg = '';
                    }
                }else return;
            });
            return msg;
        }
        this.dataSourceData.catalog = this.dataSourceData.catalog != undefined ?
            this.dataSourceData.catalog.trim() : null;
        this.dataSourceData.schema = this.dataSourceData.schema.trim();
        this.dataSourceData.type = this.dataSourceData.type != undefined ?
            this.dataSourceData.type.trim() : null;
        this.dataSourceData.username = this.dataSourceData.username.trim();
        return '';
    }

    public syncDataSource(dataSource) {
        let self = this;
        if (dataSource.dataEngine != null && (dataSource.dataEngine.type == 'PRESTO' || dataSource.dataEngine.type == 'SSAS')) {
            let r = confirm('Are you sure you want to sync all record formats for ' + dataSource.name + ' ?');
            if (r) {
                self.dataSourceService.syncAllRecordFormatsInDataSource(dataSource.id).then((res) => {
                    let msg = res.success == true ? self.toastr.showSuccess('Record formats are synced successfully') :
                        self.toastr.showError('Unable to sync record formats of "' + dataSource.name + '"');
                });
            }
        } else {
            let r = confirm('Are you sure you want to sync ' + dataSource.name + ' ?');
            if (r) {
                self.dataSourceService.syncDataSource(dataSource.id).then((res) => {
                    let msg = res.success == true ? self.toastr.showSuccess('Sync was successful') :
                        self.toastr.showError('Unable to Sync');
                });
            }
        }

    }

    public confirmChangeOfEngine(event) {
        if (event.target.value != 'none') {
            if(this.dataSourceData.storageType && this.dataSourceData.storageType == 'SQLSERVER'){
                let ind = this.dataEngineList.findIndex(x=> x.id == +event.target.value);
                this.isSSaSS = this.dataEngineList[ind].type != 'PRESTO';
                if(this.isSSaSS){
                    this.dataSourceData.catalog = '';
                    this.dataSourceData.location = '';
                }
            }
            this.dataSourceData.dataEngineId = +event.target.value;
        } else {
            this.dataSourceData.dataEngineId = null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dataSource.component.ts